<div mat-dialog-title class="d-flex align-items-center">
  <div class="d-flex align-items-center w-100">
    <p color="red" class="dhl-dialog-titlee">{{ dialogData.title ? dialogData.title : 'Confirmar' }}</p>
  </div>
  <div class="flex-shrink-1">
    <div class="position-absolute top-0 end-0 p-2">
      <button mat-icon-button [mat-dialog-close]="false" color="accent">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="row text-des">
    <div class="col">
      <!-- {{ dialogData.message }} -->
      <div class="scrol-info">
        <div class="row">
          <div class="col d-flex justify-content-center">
            <p> <strong>AVISO IMPORTANTE:</strong></p>
          </div>
        </div>
        <div class="row">
          <div class="col d-flex justify-content-center">
            <p>
              <strong>
                <!--Al contratar el Servicio Prepago de DHL Express México, S.A. de C.V. (en lo sucesivo
                DHL) con domicilio en Avenida Fuerza Aérea Mexicana Numero 540, Col. Federal,
                Alcaldía Venustiano Carranza, Ciudad de México, CP. 15700, con RFC
                DEM8801152E9, usted en calidad de “Remitente”, acuerda en su nombre y en
                nombre del destinatario del Envío (“Destinatario”) y de cualquier persona
                interesada en el Envío, que se aplicarán los presentes Términos y Condiciones.-->
                Al contratar el Servicio Prepago de DHL Express México, S.A. de C.V. (en lo sucesivo
                DHL) con domicilio en Avenida Fuerza Aérea Mexicana Numero 540, Col. Federal,
                Alcaldía Venustiano Carranza, Ciudad de México, CP. 15700, con RFC
                DEM8801152E9, usted en calidad de “Remitente”, acuerda en su nombre y en
                nombre del destinatario del Envío (“Destinatario”) y de cualquier persona
                interesada en el Envío, que se aplicarán los presentes Términos y Condiciones.



              </strong>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>
                <!--“Envío” significa todos los documentos o paquetes que viajan amparados por una
                guía aérea de transporte y que pueden ser transportados por el medio de
                transporte que DHL considere idóneo, incluido el transporte aéreo, por carretera o
                a través de cualquier otro medio de transporte. Se entenderá como “Guía y/o
                Guías” el documento producido por los sistemas automatizados de DHL o del
                Remitente que incluye la información completa del Envío en cuestión, conforme a
                las características establecidas en la legislación mexicana. “Orden de Compra” se
                entenderá como el documento que detallará el precio, cantidades y cualquier
                información adicional de los productos adquiridos por el comprador.
                “Herramienta de Prepago” se entenderá como el portal de comercio de DHL
                utilizado para la generación de Guías de Servicio Prepago, en la cual el Cliente
                podrá gestionar, procesar y administrarlas.-->
                “Envío” significa todos los documentos o paquetes que viajan amparados por una
                guía aérea de transporte y que pueden ser transportados por el medio de
                transporte que DHL considere idóneo, incluido el transporte aéreo, por carretera o
                a través de cualquier otro medio de transporte. Se entenderá como “Guía y/o
                Guías” el documento producido por los sistemas automatizados de DHL o del
                Remitente que incluye la información completa del Envío en cuestión, conforme a
                las características establecidas en la legislación mexicana. “Orden de Compra” se
                entenderá como el documento que detallará el precio, cantidades y cualquier
                información adicional de los productos adquiridos por el comprador.
                “Herramienta de Prepago” se entenderá como el portal de comercio de DHL
                utilizado para la generación de Guías de Servicio Prepago, en la cual el Cliente
                podrá gestionar, procesar y administrarlas.

              </strong>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>1. </strong>
              <!--El Remitente reconoce y acepta de manera expresa pagar a DHL el valor total
              expresado en la Orden de Compra por concepto del Servicio Prepago, el cual será
              calculado de acuerdo con las tarifas publicadas en el momento de la compra, en la Guía
              de Servicios y Precios respecto del producto denominado “Express Domestic Prepaid”
              que se encuentra en: https://mydhl.express.dhl/mx/es/home.html. La Guía de
              Servicio y Precios podrá ser modificada en cualquier momento por DHL en cualquier
              momento sin responsabilidad alguna.-->
              El Remitente reconoce y acepta de manera expresa pagar a DHL el valor total
              expresado en la Orden de Compra por concepto del Servicio Prepago, el cual será
              calculado de acuerdo con las tarifas publicadas en el momento de la compra, en la Guía
              de Servicios y Precios respecto del producto denominado “Express Domestic Prepaid”
              que se encuentra en: https://mydhl.express.dhl/mx/es/home.html. La Guía de
              Servicio y Precios podrá ser modificada en cualquier momento por DHL en cualquier
              momento sin responsabilidad alguna.



            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>2. </strong>
              <!--Las Guías del Servicio Prepago serán abonadas al perfil del Remitente generado
              dentro de la Herramienta de Prepago, de acuerdo con los siguientes plazos:-->
              Las Guías del Servicio Prepago serán abonadas al perfil del Remitente generado
              dentro de la Herramienta de Prepago, de acuerdo con los siguientes plazos:
            </p>
            <p>
              <!--a) Se abonarán de manera inmediata en caso de haber realizado el pago total del
              Servicio Prepago con tarjeta bancaria.-->
              a) Se abonarán de manera inmediata en caso de haber realizado el pago total del
              Servicio Prepago con tarjeta bancaria.
            </p>
            <p>
              <!--b) Se abonarán en un plazo máximo de 24 a 72 horas en caso de haber realizado el
              pago total a través de transferencia bancaria.-->
              b) Se abonarán en un plazo máximo de 24(veinticuatro) a 72(setenta y dos) horas en caso de haber realizado el
              pago total a través de transferencia bancaria.
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <p>
              <strong>3. </strong>
              <!--Las Guías del Servicio Prepago estarán vigentes en la Herramienta de Prepago
              durante 18 (Dieciocho) meses contados a partir del día en que hayan sido pagadas a
              DHL, una vez trascurrido dicho periodo las Guías del Servicio Prepago que no hayan
              sido utilizadas serán canceladas y no serán aceptadas, ni reembolsadas por DHL.-->
              Las Guías del Servicio Prepago estarán vigentes en la Herramienta de Prepago
              durante 18 (Dieciocho) meses contados a partir del día en que hayan sido pagadas a
              DHL, una vez trascurrido dicho periodo las Guías del Servicio Prepago que no hayan
              sido utilizadas serán canceladas y no serán aceptadas, ni reembolsadas por DHL.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>4. </strong>
              <!--Si la Guía de Servicio Prepago ha sido impresa y no se utiliza dentro de los 7 días
  naturales posteriores, el Envío ya no podrá ser utilizado, por lo que DHL no realizará
  ningún reembolso ni reactivación de la Guía.-->
              Si la Guía de Servicio Prepago ha sido impresa y no se utiliza dentro de los 7(siete) dias
              naturales posteriores, el Envío ya no podrá ser utilizado, por lo que DHL no realizará
              ningún reembolso ni reactivación de la Guía.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>5. </strong>
              <!--El Servicio Prepago no incluye recolección a domicilio, por lo que el Remitente
              deberá acudir personalmente a cualquier punto de venta de DHL para depositar el
              Envío.-->
              El Servicio Prepago no incluye recolección a domicilio, por lo que el Remitente
              deberá acudir personalmente a cualquier punto de venta de DHL para depositar el Envío.
            </p>
            <p>
              <!--En caso de que el Remitente solicite la recolección de los Servicios Prepago a través de
              My DHL+y/o Drop off DHL estará facultado para retornar y/o detener el Envío sin
              reembolso por parte de DHL.-->
              En caso de que el Remitente solicite la recolección de los Servicios Prepago a través de My DHL+y/o
              Drop off DHL estará facultado para retornar y/o detener el Envío sin reembolso por parte de DHL.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>6. </strong>
              <!--El Servicio Prepago aplica únicamente para envíos nacionales y su entrega no
              esta garantizada en un horario en específico. Para el Servicio Prepago no se podrán
              contratar servicios opcionales.-->
              El Servicio Prepago aplica únicamente para envíos nacionales y su entrega no
              está garantizada en un horario en específico. Para el Servicio Prepago no se podrán
              contratar servicios opcionales.

            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>7. </strong>
              <!--El Envío realizado con el Servicio Prepago no podrá exceder el límite máximo
  de peso equivalente a 1 (un) Kilogramo real o volumétrico, por lo que es obligación del
  Remitente cerciorarse que el peso del Envío se encuentre dentro de dicho límite.-->
              El Envío realizado con el Servicio Prepago no podrá exceder el límite máximo
              de peso equivalente a 1 (un) Kilogramo real o volumétrico, por lo que es obligación del
              Cliente cerciorarse que el peso del Envío se encuentre dentro de dicho límite.


            </p>
            <p>
              <!--En cualquier momento DHL tendrá la facultad de pesar y medir él Envió para verificar
              el peso real o volumétrico, aplicándose el que resulte mayor. El peso volumétrico no
              podrá rebasar 1 kilogramo y será el resultado de Largo X Ancho X Alto en
              centímetros/5000. Este es un método estándar utilizado en la industria de carga y
              aérea según Resolución de la IATA.-->
            </p>
            <p>
              <!--En caso de que DHL confirme que el Envío tiene un peso superior a lo establecido en la
                  presente cláusula de los presentes Términos y Condiciones, DHL tendrá la facultad de
                  no aceptar el Envío e invitar al cliente a adquirir un nuevo producto que cumpla con las
                  características de su Envío, por consiguiente, la guía utilizada no podrá ser
                  reembolsada por DHL.-->
              Sin perjuicio de las restricciones de peso aplicables al Servicio Prepago, DHL llevará a cabo revisiones periódicas y generales respecto del uso de las Guías por parte del Remitente, con el objeto de verificar el cumplimiento de las condiciones aplicables al Servicio. Dichas revisiones podrán comprender, de manera enunciativa mas no limitativa, la validación del peso físico y/o volumétrico de los Envíos, la correcta aplicación de tarifas, el uso adecuado de las Guías y cualquier otro elemento operativo o logístico que permita identificar Envíos que excedan los parámetros permitidos.

              Para tales efectos, DHL podrá emitir las notificaciones que considere oportunas, conforme a lo previsto en el numeral 13 de los presentes Términos y Condiciones.

              En caso de que DHL verifique que un Envío excede el límite máximo de peso permitido conforme a lo establecido en el presente apartado, DHL estará facultado para: (i) rechazar el Envío e invitar al Remitente a adquirir un producto que se adecúe a las características del mismo, sin que ello implique obligación alguna de reembolso respecto de la guía previamente utilizada; y (ii) aplicar cualquiera de las sanciones señaladas en el numeral 13 de estos Términos y Condiciones.

            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>8. </strong>
              <!--En caso de que el Remitente no solicite su factura al momento de la compra, se
              generará una factura genérica y sólo podrá solicitar su proceso de refacturación a
              través del siguiente correo: facturacion.mx@dhl.com. El proceso de refacturación
              únicamente podrá ser solicitado por el Remitente dentro del mismo año en que se
              realizó el pago del Servicio Prepago.-->
              En caso de que el Remitente no solicite su factura al momento de la compra,
              se generará una factura genérica y sólo podrá solicitar su proceso de refacturación
              a través del siguiente correo: facturacion.mx@dhl.com. El proceso de refacturación
              únicamente podrá ser solicitado por el Remitente dentro del mismo año en que se realizó
              el pago del Servicio Prepago.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>9. </strong>
              <!--El Remitente deberá entregar el Envío debidamente cerrado y correctamente
              empaquetado conforme a su naturaleza para su transportación por DHL, éste último
              quedará eximido de responsabilidad por cualquier daño que sufra el Envío derivado
              por el empaque incorrecto del mismo. Si el Remitente requiere de empaque, DHL sólo
              le podrá proporcionar flyer o sobre en las tiendas de DHL-->
              El Remitente deberá entregar el Envío debidamente cerrado y correctamente
              empaquetado conforme a su naturaleza para su transportación por DHL,
              éste último quedará eximido de responsabilidad por cualquier daño que sufra
              el Envío derivado por el empaque incorrecto del mismo. Si el Remitente requiere
              de empaque, DHL sólo le podrá proporcionar flyer o sobre en las tiendas de DHL.

            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>10. </strong>
              <!--Una vez realizada la compra de las Guías del Servicio Prepago en cualquiera de
              nuestros canales de venta, no podrá ser cancelada y no es elegible para cambios ni
              devoluciones.-->
              Una vez realizada la compra de las Guías del Servicio Prepago en cualquiera de
              nuestros canales de venta, no podrá ser cancelada y no es elegible para cambios
              ni devoluciones.

            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>11. </strong>
              <!--El Remitente que desee registrarse para el uso continuo de Servicio Prepago
              completará la información requerida en la sección de registro de la Herramienta de
              Prepago. Mediante el envío de un correo electrónico de activación, DHL confirmará
              el registro y las funciones de la Herramienta de Prepago podrán ser utilizadas
              inmediatamente. La Herramienta de Prepago podrá ser visualizada a través del
              siguiente link: https://prepago.dhl.com.mx/Prepaid/home/homepage.-->
              El Remitente que desee registrarse para el uso continuo de Servicio Prepago
              completará la información requerida en la sección de registro de la Herramienta de
              Prepago. Mediante el envío de un correo electrónico de activación, DHL confirmará
              el registro y las funciones de la Herramienta de Prepago podrán ser utilizadas
              inmediatamente. La Herramienta de Prepago podrá ser visualizada a través del
              siguiente link: https://prepago.dhl.com.mx/Prepaid/home/homepage.

            </p>
            <p>
              <!--DHL se reserva el derecho de verificar la autenticidad de los correos electrónicos
              proporcionados y restringir el acceso a aquellos usuarios cuya información no esté
              debidamente confirmada.-->
              DHL se reserva el derecho de verificar la autenticidad de los correos electrónicos
              proporcionados y restringir el acceso a aquellos usuarios cuya información
              no esté debidamente confirmada.

            </p>
            <p>
              <!--El Remitente no deberá compartir sus credenciales de acceso de la Herramienta de
              Prepago. En particular, el Remitente mantendrá confidenciales los permisos de acceso
              y uso que le asignó DHL, los protegerá contra el acceso de terceras partes no
              autorizadas y no los compartirá con usuarios no autorizados. Solo las personas con
              necesidad de acceder a la Herramienta de Prepago a los efectos de usar las funciones
              en nombre del Cliente, serán autorizadas por el Cliente (“Usuario Autorizado”). El
              Remitente notificará a los Usuarios Autorizados sobre su obligación y obtendrá el
              correspondiente compromiso y responsabilidad de los Usuarios Autorizados. El
              Remitente reconoce su propia responsabilidad por la salvaguarda, manejo y uso de la
              Herramienta de Prepago, también en relación con los envíos que puedan ser
              solicitados por terceros a través de la Herramienta de Prepago. El Remitente acuerda
              notificar a DHL inmediatamente de cualquier uso no autorizado de la cuenta o
              contraseña del Remitente, o cualquier otra brecha en la seguridad.-->
              El Remitente no deberá compartir sus credenciales de acceso de la Herramienta de Prepago.
              En particular, el Remitente mantendrá confidenciales los permisos de acceso y uso que le
              asignó DHL, los protegerá contra el acceso de terceras partes no autorizadas y no los compartirá
              con usuarios no autorizados. Solo las personas con necesidad de acceder a la Herramienta de Prepago
              a los efectos de usar las funciones en nombre del Remitente serán autorizadas por el Remitente (“Usuario
              Autorizado”). El Remitente notificará a los Usuarios Autorizados sobre su obligación y obtendrá el
              correspondiente compromiso y responsabilidad de los Usuarios Autorizados.
              El Remitente reconoce su propia responsabilidad por la salvaguarda, manejo y uso de la Herramienta
              de Prepago, también en relación con los envíos que puedan ser solicitados por terceros a través de
              la Herramienta de Prepago. El Remitente acuerda notificar a DHL inmediatamente de cualquier uso no
              autorizado de la cuenta o contraseña del Remitente, o cualquier otra brecha en la seguridad.
            </p>
            <p>
              <!--A menos que se indique específicamente dentro de la Herramienta de Prepago, las
              partes brindarán toda la información en forma electrónica dentro de la Herramienta
              de Prepago, incluyendo facturas. El Remitente asegurará que toda información que él
              provea a DHL a través de la Herramienta de Prepago sea completa, correcta y exacta.
              El Remitente será el único responsable de cualquier daño o consecuencia que pueda
              surgir del uso de información falsa, incorrecta o incompleta.-->
              A menos que se indique específicamente dentro de la Herramienta de Prepago, las
              partes brindarán toda la información en forma electrónica dentro de la Herramienta
              de Prepago, incluyendo facturas. El Remitente asegurará que toda información que él
              provea a DHL a través de la Herramienta de Prepago sea completa, correcta y exacta.

              El Remitente será el único responsable de cualquier daño o consecuencia que pueda
              surgir del uso de información falsa, incorrecta o incompleta.


            </p>
            <p>
              <!--EL Remitente indemnizará a DHL en toda su extensión por toda responsabilidad, costo,
                  demanda, causa de acción, daños y gastos que surjan como consecuencia o
                  relacionados de alguna manera con cualquier brecha y/o incumplimiento de lo
                  establecido en este numeral por el Remitente durante el uso de la Herramienta de
                  Prepago.
                  DHL puede terminar o suspender el uso de la Herramienta de Prepago en cualquier
                  momento y a su sola discreción. Ante dicha suspensión o terminación, el Remitente
                  debe inmediatamente (a) descontinuar su uso de Prepago y (b) borrar cualquier copia
                  que haya realizado-->
              EL Remitente indemnizará a DHL en toda su extensión por toda responsabilidad, costo,
              demanda, causa de acción, daños y gastos que surjan como consecuencia o
              relacionados de alguna manera con cualquier brecha y/o incumplimiento de lo
              establecido en este numeral por el Remitente durante el uso de la Herramienta de Prepago.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>12. </strong>
              <!--El número mínimo de Guías por Orden de Compra para brindar Servicio Prepago
              es de 10. El número máximo de Guías permitidas por Orden de Compra es de 15,000
              guías. DHL se reserva el derecho de revisar y modificar este límite en cualquier
              momento.-->
              El número mínimo de Guías por Orden de Compra para brindar Servicio Prepago es de 10.
              El número máximo de Guías permitidas por Orden de Compra es de 15,000 guías. DHL se
              reserva el derecho de revisar y modificar este límite en cualquier momento.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>13. </strong>
              <!--En todo lo que no se contraponga con lo establecido en el presente documento,
              el Remitente acepta y reconoce que los servicios de mensajería y paquetería serán
              prestados de conformidad con lo establecido en los términos y condiciones de
              transporte de DHL publicados en la página de internet www.dhl.com.mx, los
              documentos y medios que los sustituyan, los cuales podrán ser modificados por DHL
              en cualquier momento. En este acto el CLIENTE se obliga a conocer y aceptar los
              mismos al momento de la realización de cada envío-->
              DHL podrá notificar al Remitente cualquier incumplimiento a los presentes Términos y Condiciones, indicando la naturaleza de la irregularidad y las medidas aplicables.

              En caso de que DHL identifique cualquier incumplimiento a estos Términos y Condiciones, DHL estará facultada, a su entera discreción, para dar por terminado el acceso del Remitente a la Herramienta de Prepago. Dicha terminación implicará, de manera inmediata, la inhabilitación de todas las Guías de Servicio Prepago generadas y no utilizadas, así como la imposibilidad de generar nuevas Guías, sin que ello genere derecho a reembolso, compensación o crédito alguno. Lo anterior aplicará, de manera enunciativa mas no limitativa, en los siguientes supuestos:

              (i) uso fraudulento, indebido o no autorizado de la Herramienta de Prepago o del Servicio Prepago;
              (ii) suministro de información falsa, incompleta o inexacta relacionada con la gestión de Envíos;
              (iii) documentación de Envíos que excedan las restricciones aplicables en materia de peso, dimensiones o cobertura.

              La terminación será efectiva de manera inmediata al momento en que DHL así lo determine. A partir de dicha terminación, el Remitente deberá cesar cualquier uso de la Herramienta de Prepago y eliminar cualquier copia o material relacionado, entendiendo que ninguna Guía previamente adquirida podrá ser utilizada con posterioridad.

              En todo lo que no se contraponga con lo establecido en el presente documento, el Remitente acepta y reconoce que los servicios de mensajería y paquetería serán prestados de conformidad con lo establecido en los términos y condiciones de transporte de DHL publicados en la página de internet www.dhl.com.mx , los documentos y medios que los sustituyan, los cuales podrán ser modificados por DHL en cualquier momento. En este acto el Remitente se obliga a conocer y aceptar los mismos al momento de la realización de cada envío.

            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>14. </strong>
              <!--En cumplimiento con de la Ley Federal de Protección de Datos Personales en
                  Posesión de Particulares y su Reglamento, DHL. hace de su conocimiento el Aviso de
                  Privacidad Integral publicado en www.dhl.com.mx-->
              En cumplimiento con de la Ley Federal de Protección de Datos Personales en Posesión de
              Particulares y su Reglamento, DHL. hace de su conocimiento el Aviso de Privacidad Integral
              publicado en www.dhl.com.mx.

            </p>
            <p>
              <!--DHL recolectará, guardará y procesará la información personal provista por el
              Remitente en la Herramienta de Prepago como se requiere para proveer el Servicio
              Prepago, de acuerdo a las leyes aplicables y al Aviso de Privacidad Integral de DHL.
              Prepago puede contener enlaces a otros sitios web de terceros como la pasarela de
              pagos IXOPAY (“Sitios Enlazados”). Estos Sitios Enlazados no están bajo el control de
              DHL y DHL no es responsable, no guarda y no respalda el contenido de dichos Sitios
              Enlazados, incluyendo cualquier información o materiales contenidos en dichos Sitios
              Enlazados. El Remitente confirma que obtuvo el consentimiento apropiado por
              cualquier data personal propiedad de un tercero, que ha provisto a DHL.-->
              DHL recolectará, guardará y procesará la información personal provista por el Remitente
              en la Herramienta de Prepago como se requiere para proveer el Servicio Prepago, de acuerdo con
              las leyes aplicables y al Aviso de Privacidad Integral de DHL. Prepago puede contener enlaces
              a otros sitios web de terceros como la pasarela de pagos IXOPAY (“Sitios Enlazados”).
              Estos Sitios Enlazados no están bajo el control de DHL y DHL no es responsable,
              no guarda y no respalda el contenido de dichos Sitios Enlazados, incluyendo cualquier información
              o materiales contenidos en dichos Sitios Enlazados. El Remitente confirma que obtuvo el consentimiento
              apropiado por cualquier data personal propiedad de un tercero, que ha provisto a DHL.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>15. </strong>
              <!--Al realizar la compra del Servicio Prepago, el Remitente acepta y reconoce
                  haber leído y entendido los presentes Términos y Condiciones, así como su
                  compromiso de cumplir con todas las disposiciones establecidas en los mismos. Es
                  responsabilidad del Remitente mantenerse informado sobre cualquier actualización o
                  modificación de estos términos a través de nuestra página web o los canales de
                  comunicación autorizados.-->
              Al realizar la compra del Servicio Prepago, el Remitente acepta y reconoce
              haber leído y entendido los presentes Términos y Condiciones, así como su
              compromiso de cumplir con todas las disposiciones establecidas en los mismos.
              Es responsabilidad del Remitente mantenerse informado sobre cualquier
              actualización o modificación de estos términos a través de nuestra página
              web o los canales de comunicación autorizados.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p>
              <strong>16. </strong>
              <!--Cualquier controversia que se derive o esté relacionada con estos Términos y
              Condiciones estará sujeta a la jurisdicción la legislación aplicable en la Ciudad de
              México. El remitente se somete irrevocablemente a dicha jurisdicción, a menos que la
              ley aplicable indique lo contrario. No obstante, si la legislación aplicable permitiera la
              elección de fuero o de jurisdicción, ésta será la determinada por DHL.-->
              Cualquier controversia que se derive o esté relacionada con estos Términos y Condiciones
              estará sujeta a la jurisdicción y la legislación aplicable en la Ciudad de México.
              El remitente se somete irrevocablemente a dicha jurisdicción, a menos que la ley aplicable
              indique lo contrario. No obstante, si la legislación aplicable permitiera la elección de fuero
              o de jurisdicción, ésta será la determinada por DHL.

            </p>
            <p>
              <!--Si alguna de las cláusulas o parte de las mismas fuera nulas o ineficaces,
              permanecerán subsistentes el resto de los Términos y Condiciones no afectados por
              la nulidad o ineficacia.-->
              Si alguna de las cláusulas o parte de estas fuera nulas o ineficaces, permanecerán
              subsistentes el resto de los Términos y Condiciones no afectados por la nulidad o ineficacia.
            </p>
            <p>
              <!--Para más información consulte el sitio web de DHL o contacte con Departamento de
              Servicio al Remitente de DHL.-->
              Para más información consulte el sitio web de DHL o contacte con Departamento de
              Servicio al Remitente de DHL.
            </p>
          </div>
        </div>
        <mat-checkbox class="example-margin" [(ngModel)]="checkValue">
          He leído y acepto los Términos y Condiciones de uso.
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <div class="margin-down">
    <a href="assets/terms/TC-y-Orden-de-Compra-Guias-Prepago-V7-29112023.pdf" download="Términos_y_condiciones_de_uso.pdf" id="red-link">Descargar</a>
  </div>
  <button *ngIf="dialogData.showCancel" mat-stroked-button color="accent" (click)="onCancel()" class="dhl-btn-secundary"
          [innerHTML]="dialogData.cancelLabel ? dialogData.cancelLabel : 'Cancelar'">
  </button>
  <button *ngIf="dialogData.showAccept" [disabled]="!checkValue" mat-flat-button cdkFocusInitial color="accent"
          (click)="onAccept()" class="dhl-btn-primary">
    {{ dialogData.acceptLabel ? dialogData.acceptLabel : 'Aceptar' }}
  </button>

</div>
